/* =============================================================================
   DAILE Mono — catalog group (2026-10-06): collection pages, /collections, search.
   Loaded by sections/mn-cat-main / mn-cat-search (defer). No dependencies; safe to load twice.

   1. View switch (Grid / Gallery / List): [data-mn-cat-views] buttons → data-mn-cat-view on
      [data-mn-cat-results]; saved in localStorage 'mn-cat-view' (the section applies it before paint);
      image `sizes` follow the view so the browser picks a sharp enough file.
   2. Filters + sort (snippets/mn-cat-facets): the sort select submits on change (normal navigation, no AJAX);
      filters are ticked in the panel and sent with "Apply" (several at once); empty price fields are not sent;
      the grid anchor (#artworks) is kept after the reload.
      Filter sheet: close button, Escape / outside click (mn.js data-mn-autoclose), page scroll locked while the
      phone sheet is open.
   3. Theme editor: re-init on section load.
   ============================================================================= */
(() => {
  'use strict';

  if (window.__mnCat) return;
  window.__mnCat = true;

  const d = document;
  const html = d.documentElement;
  const VIEW_KEY = 'mn-cat-view';
  const VIEWS = ['grid', 'gallery', 'list'];
  const SIZES = {
    grid: '(min-width: 1200px) 24vw, (min-width: 750px) 32vw, 50vw',
    gallery: '(min-width: 750px) 48vw, 100vw',
    list: '(min-width: 750px) 88px, 64px',
  };

  const once = (el, key) => {
    const attr = `data-mn-cat-ready-${key}`;
    if (el.hasAttribute(attr)) return false;
    el.setAttribute(attr, '');
    return true;
  };

  /* 1. Views ================================================================ */

  const readView = () => {
    try {
      const v = window.localStorage.getItem(VIEW_KEY);
      return VIEWS.indexOf(v) > -1 ? v : 'grid';
    } catch (e) {
      return 'grid';
    }
  };

  const applyView = (results, group, view) => {
    results.setAttribute('data-mn-cat-view', view);
    group.querySelectorAll('[data-mn-cat-view-set]').forEach((btn) => {
      btn.setAttribute('aria-pressed', String(btn.getAttribute('data-mn-cat-view-set') === view));
    });
    results.querySelectorAll('.mn-cat-card__img').forEach((img) => {
      if (img.getAttribute('sizes') !== SIZES[view]) img.setAttribute('sizes', SIZES[view]);
    });
  };

  const initViews = (root) => {
    root.querySelectorAll('[data-mn-cat-views]').forEach((group) => {
      if (!once(group, 'views')) return;
      const section = group.closest('[data-mn-cat]') || d;
      const results = section.querySelector('[data-mn-cat-results]');
      if (!results) return;
      group.hidden = false;
      applyView(results, group, results.getAttribute('data-mn-cat-view') || readView());
      group.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-mn-cat-view-set]');
        if (!btn) return;
        const view = btn.getAttribute('data-mn-cat-view-set');
        if (VIEWS.indexOf(view) < 0) return;
        applyView(results, group, view);
        try { window.localStorage.setItem(VIEW_KEY, view); } catch (err) { /* private mode */ }
      });
    });
  };

  /* 2. Facets =============================================================== */

  const submitForm = (form) => {
    // Empty price fields and an untouched default sort never reach the address.
    form.querySelectorAll('input[data-mn-cat-price]').forEach((input) => {
      input.disabled = input.value.trim() === '';
    });
    const anchor = form.getAttribute('data-mn-cat-anchor') || '';
    if (anchor) {
      const action = (form.getAttribute('action') || '').split('#')[0];
      form.setAttribute('action', action + anchor);
    }
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  };

  const lockFor = (details) => {
    const phone = window.matchMedia('(max-width: 749px)');
    details.addEventListener('toggle', () => {
      if (details.open && phone.matches) html.classList.add('mn-lock');
      else if (!d.querySelector('.mn-cat-filter[open]')) html.classList.remove('mn-lock');
    });
  };

  const initFacets = (root) => {
    root.querySelectorAll('form[data-mn-cat-facets]').forEach((form) => {
      if (!once(form, 'facets')) return;
      form.addEventListener('change', (e) => {
        const t = e.target;
        if (!t) return;
        if (t.matches('[data-mn-cat-sort]')) submitForm(form);
      });
      form.addEventListener('submit', () => {
        form.querySelectorAll('input[data-mn-cat-price]').forEach((input) => {
          input.disabled = input.value.trim() === '';
        });
        const anchor = form.getAttribute('data-mn-cat-anchor') || '';
        if (anchor) form.setAttribute('action', (form.getAttribute('action') || '').split('#')[0] + anchor);
      });
      form.querySelectorAll('.mn-cat-filter').forEach((details) => {
        lockFor(details);
        const close = details.querySelector('[data-mn-cat-filter-close]');
        if (close) {
          close.addEventListener('click', () => {
            details.open = false;
            const summary = details.querySelector('summary');
            if (summary) summary.focus();
          });
        }
      });
    });
  };

  /* 3. Init ================================================================= */

  const init = (root) => {
    initViews(root);
    initFacets(root);
  };

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', () => init(d));
  else init(d);
  d.addEventListener('shopify:section:load', (e) => init(e.target));
})();
